import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  loading_moncash: false,
};

const slice = createSlice({
  name: "sendmoncash",
  initialState,
  reducers: {
    // START LOADING
    startLoadingM(state) {
      state.isLoading = true;
      state.loading_moncash = true;
    },
    stopLoadingM(state) {
      state.isLoading = false;
      state.loading_moncash = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // RESET STATE
    resetState() {
      return initialState;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  resetState,
  startLoadingM,
  stopLoadingM,
} = slice.actions;

// ----------------------------------------------------------------------

export async function fxRateMoncash(amount, method = "moncash") {
  const response = await axios.post(
    `/api/v1/dashboard-supervisor/fx-rate-moncash/`,
    {
      amount,
      method,
    }
  );
  return response.data;
}

export async function makeMoncash(data, method = "moncash") {
  const response = await axios.post(
    `/api/v1/dashboard-supervisor/create-ticket-moncash`,
    {
      ...data,
      method,
    }
  );
  return response.data;
}
